import { addressList } from '@/mocks/data';

export default function AddressList() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            最新可用地址
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            以下地址均经过实时检测，确保可用性。建议收藏多个备用地址以防万一
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {addressList.map((addr) => (
            <div
              key={addr.id}
              className="relative group p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-3">
                <span
                  className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                    addr.type === 'primary'
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}
                >
                  {addr.label}
                </span>
                <span
                  className={`flex items-center gap-1.5 text-xs font-medium ${
                    addr.status === 'normal' ? 'text-accent-600' : 'text-secondary-500'
                  }`}
                >
                  <span
                    className={`w-1.5 h-1.5 rounded-full ${
                      addr.status === 'normal' ? 'bg-accent-500' : 'bg-secondary-400'
                    }`}
                  />
                  {addr.statusText}
                </span>
              </div>

              <div className="h-20 bg-background-200/50 rounded-lg flex items-center justify-center mb-3">
                <i className="ri-shield-check-line text-2xl text-background-400" />
              </div>

              <div className="flex items-center justify-center">
                <span className="text-xs text-foreground-500 bg-background-200/70 px-3 py-1.5 rounded-md">
                  点击查看地址
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-400 bg-secondary-50 inline-flex items-center gap-2 px-4 py-2 rounded-full">
            <i className="ri-information-line" />
            地址状态每30分钟自动检测更新
          </p>
        </div>
      </div>
    </section>
  );
}